import { api } from 'src/api/axios';

export const useDeleteNotify = (id: number | string) => api.delete(`/api/cms/notification/${id}`);
